import { SelectedEntitiesModel } from '@cw-elements/mfe-setup/entities-hall/entities-hall.model';
import { createWithEqualityFn } from 'zustand/traditional';

interface HallOfEntitiesState {
  selectedEntities: SelectedEntitiesModel;
}

interface HallOfEntitiesActions {
  setSelectedEntities: (newEntities: SelectedEntitiesModel) => void;
}

export const hallOfEntitiesStore = createWithEqualityFn<
  HallOfEntitiesState & HallOfEntitiesActions
>((set) => ({
  selectedEntities: {},
  setSelectedEntities: (newEntities) => {
    set((state) => ({ ...state, selectedEntities: newEntities }));
  },
}));
